import {
    GET_LOANS_REQUEST,
    GET_LOANS_SUCCESS,
    GET_LOANS_FAILED,
    GET_LOAN_BY_NUMBER_REQUEST,
    GET_LOAN_BY_NUMBER_SUCCESS,
    GET_LOAN_BY_NUMBER_FAILED,
    GET_LOAN_SUMMARY_REQUEST,
    GET_LOAN_SUMMARY_SUCCESS,
    GET_LOAN_SUMMARY_FAILED,
    GET_CUSTOMER_STEP_REQUEST,
    GET_CUSTOMER_STEP_SUCCESS,
    GET_CUSTOMER_STEP_FAILED,
    GET_GUARANTOR_STEP_REQUEST,
    GET_GUARANTOR_STEP_SUCCESS,
    GET_GUARANTOR_STEP_FAILED,
    GET_VEHICLE_STEP_REQUEST,
    GET_VEHICLE_STEP_SUCCESS,
    GET_VEHICLE_STEP_FAILED,
    GET_LOAN_DETAILS_STEP_REQUEST,
    GET_LOAN_DETAILS_STEP_SUCCESS,
    GET_LOAN_DETAILS_STEP_FAILED,
    CREATE_LOAN_REQUEST,
    CREATE_LOAN_SUCCESS,
    CREATE_LOAN_FAILED,
    CREATE_LOAN_WITH_CUSTOMER_REQUEST,
    CREATE_LOAN_WITH_CUSTOMER_SUCCESS,
    CREATE_LOAN_WITH_CUSTOMER_FAILED,
    ADD_CUSTOMER_REQUEST,
    ADD_CUSTOMER_SUCCESS,
    ADD_CUSTOMER_FAILED,
    ADD_KYC_REQUEST,
    ADD_KYC_SUCCESS,
    ADD_KYC_FAILED,
    ADD_GUARANTOR_REQUEST,
    ADD_GUARANTOR_SUCCESS,
    ADD_GUARANTOR_FAILED,
    ADD_VEHICLE_REQUEST,
    ADD_VEHICLE_SUCCESS,
    ADD_VEHICLE_FAILED,
    ADD_LOAN_DETAILS_REQUEST,
    ADD_LOAN_DETAILS_SUCCESS,
    ADD_LOAN_DETAILS_FAILED,
    APPROVE_LOAN_REQUEST,
    APPROVE_LOAN_SUCCESS,
    APPROVE_LOAN_FAILED,
    REJECT_LOAN_REQUEST,
    REJECT_LOAN_SUCCESS,
    REJECT_LOAN_FAILED,
    CANCEL_LOAN_REQUEST,
    CANCEL_LOAN_SUCCESS,
    CANCEL_LOAN_FAILED,
    GET_LOAN_STATISTICS_REQUEST,
    GET_LOAN_STATISTICS_SUCCESS,
    GET_LOAN_STATISTICS_FAILED,
    GET_PENDING_BY_AGE_REQUEST,
    GET_PENDING_BY_AGE_SUCCESS,
    GET_PENDING_BY_AGE_FAILED,
    CLEAR_CURRENT_LOAN,
    CLEAR_LOAN_ERRORS,
    RESET_LOAN_SUCCESS
} from '../actions/LoansActions';

const initialState = {
    // Loans list and pagination
    listdata: [],
    pagination: {
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        itemsPerPage: 10,
        hasNextPage: false,
        hasPreviousPage: false
    },
    
    // Current loan details
    currentLoan: null,
    loanSummary: null,
    
    // Statistics
    statistics: {
        totalLoans: 0,
        pendingApproval: 0,
        approvedLoans: 0,
        rejectedLoans: 0,
        cancelledLoans: 0,
        draftLoans: 0,
        totalLoanAmount: 0,
        totalApprovedAmount: 0
    },
    
    pendingByAge: {
        pending_0_7_days: 0,
        pending_8_15_days: 0,
        pending_16_30_days: 0,
        pending_over_30_days: 0
    },
    
    // UI State
    loading: false,
    error: null,
    validationErrors: null,
    success: false
};

const LoansReducer = (state = initialState, action) => {
    switch (action.type) {
        // ============================================
        // GET LOANS LIST
        // ============================================
        case GET_LOANS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_LOANS_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.loans || [],
                pagination: {
                    currentPage: action.payload.pagination?.currentPage || 1,
                    totalPages: action.payload.pagination?.totalPages || 0,
                    totalItems: action.payload.pagination?.totalRecords || 0,
                    itemsPerPage: action.payload.pagination?.recordsPerPage || 10,
                    hasNextPage: action.payload.pagination?.currentPage < action.payload.pagination?.totalPages,
                    hasPreviousPage: action.payload.pagination?.currentPage > 1
                },
                error: null
            };

        case GET_LOANS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                listdata: [],
                pagination: initialState.pagination
            };

        // ============================================
        // GET LOAN BY NUMBER (FULL DETAILS)
        // ============================================
        case GET_LOAN_BY_NUMBER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_LOAN_BY_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: action.payload,
                error: null
            };

        case GET_LOAN_BY_NUMBER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                currentLoan: null
            };

        // ============================================
        // GET LOAN SUMMARY (LIGHTWEIGHT)
        // ============================================
        case GET_LOAN_SUMMARY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_LOAN_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                loanSummary: action.payload,
                error: null
            };

        case GET_LOAN_SUMMARY_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // GET CUSTOMER STEP DATA
        // ============================================
        case GET_CUSTOMER_STEP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_CUSTOMER_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload,
                    customer: action.payload.customer
                },
                error: null
            };

        case GET_CUSTOMER_STEP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // GET GUARANTOR STEP DATA
        // ============================================
        case GET_GUARANTOR_STEP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_GUARANTOR_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload,
                    guarantors: action.payload.guarantor ? [action.payload.guarantor] : action.payload.guarantors || []
                },
                error: null
            };

        case GET_GUARANTOR_STEP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // GET VEHICLE STEP DATA
        // ============================================
        case GET_VEHICLE_STEP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_VEHICLE_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload,
                    vehicle: action.payload.vehicle
                },
                error: null
            };

        case GET_VEHICLE_STEP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // GET LOAN DETAILS STEP DATA
        // ============================================
        case GET_LOAN_DETAILS_STEP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_LOAN_DETAILS_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload,
                    loanDetails: action.payload.loanDetails
                },
                error: null
            };

        case GET_LOAN_DETAILS_STEP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // CREATE LOAN APPLICATION
        // ============================================
        case CREATE_LOAN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case CREATE_LOAN_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: action.payload,
                error: null,
                success: true
            };

        case CREATE_LOAN_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // CREATE LOAN WITH CUSTOMER (STEP 0-1)
        // ============================================
        case CREATE_LOAN_WITH_CUSTOMER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case CREATE_LOAN_WITH_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: action.payload,
                error: null,
                success: true
            };

        case CREATE_LOAN_WITH_CUSTOMER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // ADD CUSTOMER (STEP 1)
        // ============================================
        case ADD_CUSTOMER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case ADD_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case ADD_CUSTOMER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // ADD KYC (STEP 2)
        // ============================================
        case ADD_KYC_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case ADD_KYC_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case ADD_KYC_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // ADD GUARANTOR (STEP 3)
        // ============================================
        case ADD_GUARANTOR_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case ADD_GUARANTOR_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case ADD_GUARANTOR_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // ADD VEHICLE (STEP 4)
        // ============================================
        case ADD_VEHICLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case ADD_VEHICLE_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case ADD_VEHICLE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // ADD LOAN DETAILS (STEP 5)
        // ============================================
        case ADD_LOAN_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                validationErrors: null,
                success: false
            };

        case ADD_LOAN_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case ADD_LOAN_DETAILS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.errors,
                success: false
            };

        // ============================================
        // APPROVE LOAN
        // ============================================
        case APPROVE_LOAN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };

        case APPROVE_LOAN_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case APPROVE_LOAN_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // ============================================
        // REJECT LOAN
        // ============================================
        case REJECT_LOAN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };

        case REJECT_LOAN_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoan: {
                    ...state.currentLoan,
                    ...action.payload
                },
                error: null,
                success: true
            };

        case REJECT_LOAN_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // ============================================
        // CANCEL LOAN
        // ============================================
        case CANCEL_LOAN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };

        case CANCEL_LOAN_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: state.listdata.map(loan =>
                    loan.loanApplicationNumber === action.payload.loanApplicationNumber
                        ? { ...loan, status: 'cancelled' }
                        : loan
                ),
                error: null,
                success: true
            };

        case CANCEL_LOAN_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        // ============================================
        // LOAN STATISTICS
        // ============================================
        case GET_LOAN_STATISTICS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_LOAN_STATISTICS_SUCCESS:
            return {
                ...state,
                loading: false,
                statistics: action.payload,
                error: null
            };

        case GET_LOAN_STATISTICS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // PENDING LOANS BY AGE
        // ============================================
        case GET_PENDING_BY_AGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_PENDING_BY_AGE_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingByAge: action.payload,
                error: null
            };

        case GET_PENDING_BY_AGE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ============================================
        // UTILITY ACTIONS
        // ============================================
        case CLEAR_CURRENT_LOAN:
            return {
                ...state,
                currentLoan: null,
                loanSummary: null,
                error: null,
                validationErrors: null,
                success: false
            };

        case CLEAR_LOAN_ERRORS:
            return {
                ...state,
                error: null,
                validationErrors: null
            };

        case RESET_LOAN_SUCCESS:
            return {
                ...state,
                success: false
            };

        default:
            return state;
    }
};

export default LoansReducer;
